import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { class: String }

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    const toggleClass = this.classValue || "collapsed"

    this.contentTargets.forEach(content => {
      content.classList.toggle(toggleClass)
    })

    this.iconTargets.forEach(icon => {
      icon.classList.toggle(toggleClass)
    })
  }

  show() {
    const toggleClass = this.classValue || "collapsed"

    this.contentTargets.forEach(content => {
      content.classList.remove(toggleClass)
    })

    this.iconTargets.forEach(icon => {
      icon.classList.remove(toggleClass)
    })
  }

  hide() {
    const toggleClass = this.classValue || "collapsed"

    this.contentTargets.forEach(content => {
      content.classList.add(toggleClass)
    })

    this.iconTargets.forEach(icon => {
      icon.classList.add(toggleClass)
    })
  }
}
